var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('BaseImg',{attrs:{"option":{
    style: {
      margin: '14px 0 0 12px',
      alignSelf: 'flex-start',
      width: '149px',
    },
    url: 'logo.png',
  }}}),_c('BaseImg',{attrs:{"option":{
    style: {
      margin: '28px auto 0',
    },
    url: 'slogan.png',
  }}}),_vm._m(0),_c('BaseBtnHome')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rules-box"},[_c('div',{staticClass:"r-body"},[_vm._v(" 1:进入游戏，点击屏幕控制水枪射击前方元素。击中水元素得100分，击中障碍物则扣50分，20秒游戏时间内达到1000分即可通关，获得抽奖机会。 "),_c('br'),_vm._v("2.每人默认2次游戏机会，首次通关后将获得连续两次抽奖机会。机会使用完毕后、还可继续传播活动给好友，即可获得更多游戏次数，通关即可继续参与抽奖。首次传播活动还可收获额外金喜～ "),_c('br'),_vm._v("3.当好友通过您的分享参与游戏，您还将自动成为队长，与你的好友组成战队，战队积分为战队所有成员最高游戏得分之和。冲击战队排行榜，还可赢取更多豪礼！ "),_c('br'),_c('br'),_c('span',[_vm._v("活动时间：")]),_c('br'),_vm._v("2022年7月12日09:00—7月16日24:00 "),_c('br'),_c('span',[_vm._v("领奖时间：")]),_c('br'),_vm._v("2022年7月17日9:00—2022年7月31日24:00 "),_c('br'),_c('span',[_vm._v("领奖方式：")]),_vm._v("线上领取，礼品快递邮寄 ")])])
}]

export { render, staticRenderFns }